var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('span',{staticClass:"labels"},[_vm._l((_vm.labels()),function(ref,index){
var label = ref.label;
var color = ref.color;
return [(_vm.leadingSpace || index > 0)?[_vm._v(_vm._s(' '))]:_vm._e(),_c('ui-label',_vm._b({},"ui-label",_vm._d({},[color,true])),[_vm._v(_vm._s(label))])]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }